import React, { Component } from "react";
import {
  Container,
  Responsive,
  Menu,
  List,
  Header,
  Transition,
  Icon
} from "semantic-ui-react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { push } from "react-router-redux";

const menuitems = [
  { id: 1, name: "Inicio", navigateTo: "/" },
  { id: 2, name: "Información", navigateTo: "/" },
  { id: 3, name: "Propiedades", navigateTo: "/propiedades" },
  { id: 4, name: "Contacto", navigateTo: "/" }
];

class InternMenu extends Component {
  constructor(props) {
    super(props);
    this.state = { mobileMenu: false };
    this.onMenuClick = this.onMenuClick.bind(this);
  }

  onMenuClick() {
    window.scroll({
      top: document.getElementById("firstContainer").offsetHeight,
      behavior: "smooth"
    });
    this.setState({ mobileMenu: !this.state.mobileMenu });
  }
  handleItemClick = navigateto => {
    this.props.push(this.props.url + navigateto);
  };

  onOptionClick(option, optionId) {
    if (option !== undefined) {
      if (optionId === 1) {
        this.props.push('/');
      }else{
        this.props.push(option);      
      }

      window.scroll({
        top: document.getElementById("firstContainer").offsetHeight,
        behavior: "smooth"
      });
      this.onMenuClick();
    }
  }

  renderInDesktop() {
    return (
      <div>
        <Container
          align="center"
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <Menu
            widths={4}
            style={{
              height: "4.2rem",
              boxShadow: "0px 0px 0px",
              border: 0,
              borderRadius: "4px",
              width: "70%",
              position: "absolute",
              bottom: "14vh"
            }}
          >
            {menuitems.map(item => {
              return (
                <Menu.Item
                  key={item.id}
                  className="mainMenuItem"
                  style={{ textTransform: "uppercase", color: "#023552" }}
                  onClick={() => {
                    if (item.navigateTo !== undefined) {
                      let newState = null;
                      if(item.id === 4){
                        newState = {
                          pathname: this.props.url + item.navigateTo,
                          state: { modelId: (this.props.currentModel)? this.props.currentModel : null }
                        };
                      }else{
                        newState = this.props.url + item.navigateTo;
                      }
                      this.props.push(newState);
                      if (item.id !== 4 && item.id !== 1) {
                        window.scroll({
                          top: document.getElementById("firstContainer")
                            .offsetHeight,
                          behavior: "smooth"
                        });
                      }
                      if (item.id === 1) {
                        this.props.push(item.navigateTo);
                      }
                    }

                    if (item.id === 4) {
                      setTimeout(() => {
                        window.scroll({
                          top: document.getElementById("contact").offsetTop,
                          behavior: "smooth"
                        });
                      }, 100);
                    }
                  }}
                >
                  {item.name}
                </Menu.Item>
              );
            })}
          </Menu>
        </Container>
      </div>
    );
  }
  renderInTablet() {
    return (
      <div>
        <Container align="center">
          <Menu
            widths={4}
            style={{
              height: "4.2rem",
              boxShadow: "0px 0px 0px",
              border: 0,
              borderRadius: "4px 4px 0px 0px",
              width: "70%"
            }}
          >
            {menuitems.map(item => {
              return (
                <Menu.Item
                  key={item.id}
                  className="mainMenuItem"
                  style={{
                    textTransform: "uppercase",
                    color: "#023552",
                    fontSize: "1rem"
                  }}
                  onClick={() => {
                    if (item.navigateTo !== undefined) {
                      let newState = null;
                      if(item.id === 4){
                        newState = {
                          pathname: this.props.url + item.navigateTo,
                          state: { modelId: (this.props.currentModel)? this.props.currentModel : null }
                        };
                      }else{
                        newState = this.props.url + item.navigateTo;
                      }
                      this.props.push(newState);

                      if (item.id !== 4 && item.id !== 1) {
                        window.scroll({
                          top: document.getElementById("firstContainer")
                            .offsetHeight,
                          behavior: "smooth"
                        });
                      }
                      if (item.id === 1) {
                        this.props.push(item.navigateTo);
                      }
                    }

                    if (item.id === 4) {
                      setTimeout(() => {
                        window.scroll({
                          top: document.getElementById("contact").offsetTop,
                          behavior: "smooth"
                        });
                      }, 100);
                    }
                  }}
                >
                  {item.name}
                </Menu.Item>
              );
            })}
          </Menu>
        </Container>
      </div>
    );
  }
  renderInMobile() {
    return (
      <div
        style={{
          height: "3.3rem",
          width: "100vw",
          backgroundColor: "white",
          alignContent: "center",
          alignSelf: "center",
          display: "flex",
          alignItems: "flex-end",
          padding: "0rem 3rem",
          justifyContent: "flex-end"
        }}
        id="mobileMenu"
      >
        <Icon
          name={this.state.mobileMenu ? "close" : "sidebar"}
          size="large"
          style={{ cursor: "pointer", position: "absolute", zIndex: 10 }}
          onClick={this.onMenuClick}
        />

        <Transition
          visible={this.state.mobileMenu}
          animation="slide down"
          duration={400}
        >
          <div className="menumIntern" align="center">
            <Header as="h3">Menú</Header>
            <List>
              {menuitems.map(item => {
                return (
                  <List.Item
                    key={item.id}
                    onClick={() => {
                      let newState = null;
                      
                      if(item.id === 4){
                        newState = {
                          pathname: this.props.url + item.navigateTo,
                          state: { modelId: (this.props.currentModel)? this.props.currentModel : null }
                        };
                      }else{
                        newState = this.props.url + item.navigateTo;
                      }

                      if (item.id === 4) {
                        setTimeout(() => {
                          window.scroll({
                            top: document.getElementById("contact").offsetTop,
                            behavior: "smooth"
                          });
                        }, 100);
                      }
                      this.onOptionClick(newState, item.id);
                    }}
                    style={{
                      color: "black",
                      marginTop: "1.5rem",
                      fontSize: "1.5rem"
                    }}
                  >
                    {item.name}
                  </List.Item>
                );
              })}
            </List>
          </div>
        </Transition>
      </div>
    );
  }
  render() {
    return (
      <div>
        <Responsive {...Responsive.onlyMobile}>
          {this.renderInMobile()}
        </Responsive>
        <Responsive {...Responsive.onlyTablet}>
          {this.renderInTablet()}
        </Responsive>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderInDesktop()}
        </Responsive>
      </div>
    );
  }
}
const mapStateToProps = ({ data }) => {
  const { pages } = data;
  return {
    pages
  };
};

const mapDispatchToProps = dispatch => {
  return {
    push: to => {
      dispatch(push(to));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(InternMenu)
);
